import Ad from "../components/Ad";
import React from "react";
import Video from "../components/Video";
import styles from "../styles/Leaderboard.module.scss";

const Leaderboard = () => (
  <div className={styles.leaderboard}>
    <div className={styles.video}>
      <Ad id="video" />
      {/* <Video /> */}
    </div>
    <div>
      <Ad className={styles.leaderboardAd} id="leaderboard" />
      <Ad className={styles.leaderboardAd} id="leaderboard_a" />
    </div>
  </div>
);

export default Leaderboard;
